import { useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import RenderComponent from '@/modules/DynamicRenderPage';
import { isInsuracePortalUser, loadPageConfig, loadStyle } from 'globalutils/fmUtils';
import ParentStyled from './style';

const Styled = loadStyle(ParentStyled, 'pages/web/Accidents');
const config = loadPageConfig();
const Title = lazy(() => import(`globalcomponents/Title`));
const Content = lazy(() => import(`@/${config.accidentsList[1].name}`));

const basicRequest = {
  displayLength: '15',
  displayStart: '1',
};

const sortColumnMapping = {
  unitId: 'vehicleName',
  work_order_id: 'idPub',
  type: 'unitType',
  reported_date: 'createDate',
  scheduled_date: 'beginDate',
  due_date: 'endDate',
  workOrderType: 'type',
  status: 'state',
};

const Accidents = (parentProps) => {
  const { fetchAccidents, list, getFilters, getDocumentToken, logBook, fetchFleetCompanies, fetchAccidentsPagination } =
    parentProps;
  const [pagination, setPagination] = useState(false);
  const [request, setRequest] = useState({ ...basicRequest });

  const history = useHistory();
  const theme = useTheme();
  const { t } = useTranslation();
  const isInsuranceUser = isInsuracePortalUser();

  const commonParentProps = { history, i18n: { t }, Styled, theme };

  const handleRequestChange = (fields) => {
    if (fields?.sortCol) {
      fields.sortCol = sortColumnMapping[fields.sortCol] || fields.sortCol;
    }
    setRequest({ ...basicRequest, ...fields });
  };

  useEffect(() => {
    if (isInsuranceUser) {
      fetchAccidentsPagination({
        apiId: 'fetchAccidentsPaginateApi',
        data: { request },
      });
    }
  }, [request, fetchAccidentsPagination, isInsuranceUser]);

  useEffect(() => {
    if (!isInsuranceUser && !list.length) {
      fetchAccidents({ apiId: 'fetchAccidentsApi' });
    }
    getFilters({ apiId: 'getFilters' });
    if (!logBook?.documentToken?.length) {
      getDocumentToken({ apiId: 'getDocToken' });
    }
    fetchFleetCompanies({ apiId: 'fetchFleetCompanies' });
  }, [
    fetchAccidents,
    fetchAccidentsPagination,
    fetchFleetCompanies,
    getDocumentToken,
    getFilters,
    isInsuranceUser,
    list.length,
    logBook?.documentToken?.length,
  ]);

  return (
    <>
      <RenderComponent
        {...config.accidentsList[0]}
        parentProps={parentProps}
        commonParentProps={commonParentProps}
        component={Title}
      />
      <RenderComponent
        {...config.accidentsList[1]}
        parentProps={{
          ...parentProps,
          changeRequest: handleRequestChange,
          request,
          pagination,
          setPagination,
        }}
        commonParentProps={commonParentProps}
        component={Content}
      />
    </>
  );
};

Accidents.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  list: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  logBook: PropTypes.object.isRequired,
  fetchAccidents: PropTypes.func.isRequired,
  fetchAccidentsPagination: PropTypes.func.isRequired,
  getFilters: PropTypes.func.isRequired,
  getDocumentToken: PropTypes.func.isRequired,
  fetchFleetCompanies: PropTypes.func.isRequired,
};

Accidents.defaultProps = {
  list: [],
  filters: {},
  logBook: {},
};

const mapStateToProps = (state) => ({
  apiStatus: state.asyncRequests,
  list: state.accidents.list,
  paginateList: state.accidents.paginateList,
  filters: state.filters,
  logBook: state.logBook,
  fleetCompanies: state.fleetCompanyList.companyList,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAccidents: (data) => dispatch.accidents.fetchData(data),
  fetchAccidentsPagination: (data) => dispatch.accidents.fetchPaginationData(data),
  getFilters: (data) => dispatch.filters.fetchData(data),
  viewReport: (data) => dispatch.viewReport.viewReportDocument(data),
  getDocumentToken: (data) => dispatch.logBook.documentToken(data),
  fetchFleetCompanies: (data) => dispatch.fleetCompanyList.fetchCompanyList(data),
});

export default connect(mapStateToProps, mapDispatchToProps)(Accidents);
